import { NgModule } from '@angular/core';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HomeModule } from './home/home.module';
import { RestaurantModule } from './restaurant/restaurant.module';
import { RouterModule, Routes } from '@angular/router';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { SmsTermsComponent } from './sms-terms/sms-terms.component';
import { CheckOutModule } from './check-out/check-out.module';
import { AuthModule } from './auth/auth.module';
import { RestaurantNotFoundComponent } from './restaurant-not-found/restaurant-not-found.component';
import { StoreContextGuard } from 'src/app/services/guards/store-context.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./restaurant/restaurant.module').then((m) => m.RestaurantModule),
    canActivate: [StoreContextGuard],
    data: { page: 'store' },
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
    data: { page: 'home' },
  },
  {
    path: 'checkout',
    loadChildren: () =>
      import('./check-out/check-out.module').then((m) => m.CheckOutModule),
    data: { page: 'checkout' },
  },
  {
    path: 'store',
    loadChildren: () =>
      import('./restaurant/restaurant.module').then((m) => m.RestaurantModule),
    data: { page: 'store' },
  },
  {
    path: 'store/:restaurantId',
    loadChildren: () =>
      import('./restaurant/restaurant.module').then((m) => m.RestaurantModule),
    data: { page: 'store' },
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    data: { page: 'auth' },
  },
  {
    path: 'filter',
    loadChildren: () =>
      import('./filter/filter.module').then((m) => m.FilterModule),
    data: { page: 'filter' },
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./account/account.module').then((m) => m.AccountModule),
    data: { page: 'account' },
  },
  {
    path: 'order-placed',
    loadChildren: () =>
      import('./order-placed/order-placed.module').then(
        (m) => m.OrderPlacedModule
      ),
    data: { page: 'order-placed' },
  },
  { path: 'terms', component: TermsOfUseComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'sms-terms', component: SmsTermsComponent },
];

@NgModule({
  declarations: [
    PageNotFoundComponent,
    RestaurantNotFoundComponent,
    PrivacyPolicyComponent,
    SmsTermsComponent,
  ],
  imports: [
    HomeModule,
    AuthModule,
    RestaurantModule,
    CheckOutModule,
    RouterModule.forChild(routes),
  ],
  exports: [HomeModule, AuthModule, RestaurantModule, CheckOutModule],
})
export class PagesModule {}
